/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const getOrderMeasurements = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ORDER_MEASURENT}${data.devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setOrderMeasurement = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SET_ORDER_MEASURENT}${payload.devOrderId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrderDesignDetail = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_DESIGN_DETAIL}/${id}/design-details`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveDesignAnnotation = async (devOrderId, designId, imageId, payload) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_DESIGN_DETAIL}/${devOrderId}${API.DESIGN_DETAILS.SAVE_ANNOTATION}/${designId}/${imageId}/save-annotation`,
      payload,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSingleDesignDetail = async (devOrderId, designId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_DESIGN_DETAIL}/${devOrderId}${API.DESIGN_DETAILS.GET_SINGLE_DESIGN}`, {
      params: { designId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrderSamples = async (devId, sampleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_SAMPLES}/${devId}/${sampleId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setAnnotedSamples = async (devId, sampleId, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_SAMPLES}/${devId}/${sampleId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadAndGetSummernoteImage = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.UPLOAD_SUMMERNOTE_IMAGES}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const orderSubmitAndDownload = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SUBMIT_DOWNLOAD}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurmentProductDetail = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_DESIGN_DETAIL}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductGradingDetail = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GRADING}/${id}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurmentData = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ORDER_MEASURENT}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMeasurementPermission = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING_SUGGESTION.SAVE_MEASUREMENT_PERMISSON}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveOrderMeasurements = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ORDER_MEASURENT}${data.devOrderId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCADFileDetail = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CADLIB}/${id}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCADSpecFileDetail = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CADSPECIFICATIONLIB}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addSpecFileToLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SPECSPECIFICATIONLIB}?fromMeasure=true`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const markComplete = async (id, params) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.MARK_COMPLETE}/${id}/measurement?isComplete=${params}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCadFromProduct = async (id, gradingGroupId) => {
  console.error('fetchCadFromProduct params', gradingGroupId);
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCHCADFROMPRODUCT}/${id}`, {
      params: { pom: true, gradingGroupId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchCadFilesFromProduct = async (data) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_CADFILES_FROM_PRODUCT}?devOrderId=${data.devOrderId}&selDevOrderId=${data.selDevOrderId}&selectedGradingLib=${data.selectedGradingLib}&type=${data.type}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setGrading = async (id, payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_GRADING}/${id}`, { ...payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchUnit = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_UNITS}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addImageToLibrary = async (id, data) => {
  try {
    console.error(data);
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_IMAGE_TO_LIBRARY}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const addCadFile = async (id, data) => {
  try {
    console.error(data);
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_CAD_FILE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const clearMeasurement = async (id, params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ORDER_MEASURENT}${id}`, params);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importXlFile = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.IMPORT_XL_FILE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Uploads a Specification workbook for one dev order. The server parses, merges, re-derives the
 * grade rules and writes Product History; the client sends only the file and the grading group.
 * @param {string} devOrderId Development order the spec belongs to.
 * @param {FormData} data Multipart body carrying `xls` and `gradingGroupId`.
 * @returns {Promise<object>} The API response envelope.
 */
export const importSpecificationXlFile = async (devOrderId, data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ORDER_MEASURENT}${devOrderId}${API.DEVELOPMENT_ORDER.IMPORT_SPECIFICATION_XLS}`,
      data,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPomDocuments = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_OHTER_DOCUMENT}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOtherDocuments = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_OHTER_DOCUMENT}/${id}?isOther=true`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDocuments = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_OHTER_DOCUMENT}/${data.id}?ids=${data.data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateDocuments = async (data) => {
  console.error('data', data);
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_OHTER_DOCUMENT}/${data.devOrderId}?id=${data.id}&fileName=${data.fileName}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getcompletionDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SET_PERMISSION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postPermissions = async (id, paramData) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.MARK_COMPLETE}/${id}/sample`, null, { params: { ...paramData } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const markAsComplete = async (paramData) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.MARK_COMPLETE}/${paramData.id}/${paramData.module}`, null, {
      params: { ...paramData.data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOrderTestingReqReport = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_TEST_REPORT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getcompletionDetails1 = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SET_PERMISSION1}/${data.type}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSpecFileDetail = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SPECLIB}/${id}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSpecFilePoms = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SPECSPECIFICATIONLIB}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSampleImageSetsSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_IMAGE_SETS_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSampleImagesSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_IMAGES_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSampleImages = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.UPDATE_SAMPLE_IMAGES}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getEcommSpecAccess = async (key) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SET_MASTER_ACCESS}`, { params: { key } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const insertDevOrder = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDevOrder = async (id, payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}/${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bulkUpdateDevOrders = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.BULK_UPDATE_DEV_ORDER}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateDevOrder = async (id, payload, reOrderFlag) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}/${id}/duplicate?isReorder=${reOrderFlag}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductTags = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_TAGS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDevOrderEditRules = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.EDIT_RULES}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const changeGrading = async (id, deselectedGrading) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHANGE_GRADING}/${id}`, { gradingGroupId: deselectedGrading });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDevOrder = async (payload) => {
  try {
    const postValue = { data: payload };
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_DEV_ORDER}`, postValue);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDevOrderById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setArchivedProduct = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ARCHIVE_PRODUCT}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setTrashProduct = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.TRASH_PRODUCT}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProduct = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setProductGroup = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_PRODUCT_GROUP}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setProductStatus = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHANGE_PRODUCT_STATUS}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCompletionDetail = async (id, payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.GET_TRAFFIC_LIGHTS.GET}/${id}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductGroupData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_GROUP}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductToGroupData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_PRODUCT_GROUP_DATA}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAdminUserDetail = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_ADMIN_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCompanyUserDetail = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_COMPANY_USERS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bulkSubmitDownload = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.BULK_SUBNIT_DOWNLOAD}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getProductReorder = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_REORDER}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const unlinkReorderProduct = async (id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_UNLINK}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductReorderList = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.REORDER_LIST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkIsSameSupplierExist = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.IS_SAME_SUPPLIER_EXIST}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSubmitHistory = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_BULK_SUBNIT_DOWNLOAD}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSupplierImages = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.UPDATE_SUPPLIER_IMAGES}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSupplierImagesSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SUPPLIER_IMAGES_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUpdatePomsToSpec = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.UPDATE_SPEC_POMS}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSelectedGradGroupData = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SELECTED_GRAD_MEASUREMENTS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveGradGroupMeasurments = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.UPDATE_SELECTED_GRAD_MEASUREMENTS}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkIfProductMeasurementsExists = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHECK_IF_PRODUCT_MEASUREMENTS_EXISTS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getAllProducts = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ALL_OPEN_PRODUCTS}`);
  } catch (error) {
    console.error(error);
  }
};

export const savePermission = async (params) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.POST_PERMISSION}/${params.type}?devOrderId=${params.devOrderId}`, params.permissionData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModule = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CUSTOM_MODULE}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveCustomModule = async (payload, customLibId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CUSTOM_MODULE_ADD_EDIT}/${customLibId}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCustomModuleId = async (devId, customLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_CUSTOM_MODULE}/${customLibId}/${devId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCustomModulePermission = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CUSTOM_MODULE_PERMISSION}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUpdatedCustomModule = async (objParam) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.REFRESH_CUSTOM_MODULE}/${objParam.devOrderId}/${objParam.customModuleLibId}/${objParam.pageId}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setProductCustomModulePermission = async (params, payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CUSTOM_MODULE_PERMISSION}`, { ...payload }, { params: { ...params } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addToBomLibrary = async (id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_CONFIG.BOM_CARD_LIST.ADD_BOM_LIBARARY}`, { ...id });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents get list
export const getSupportingDesignDetails = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents save
export const saveSupportingDesignDetails = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateSupportingDesignDetails = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}/${data.editId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSupportingDesignDetails = async (id, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents — list resumable (unfinished) uploads for the dev order
export const getResumableSupportingUploads = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}/pending-uploads`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// all of the logged-in user's resumable uploads across dev orders + modules (global widget, any page)
export const getAllResumableUploads = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}/design/supporting-doc/pending-uploads`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents — count pages of a PDF already in S3 (backs the 10-page Add-to-Design gate)
export const getSupportingDocPdfPageCount = async (id, objectKey) => {
  try {
    return await apiClient.get(`${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}/pdf-page-count`, {
      params: { objectKey },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents — resolve resume state (uploadId + already-uploaded parts) for one task
export const getSupportingUploadResumeState = async (id, taskId) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}/pending-uploads/${taskId}/resume-state`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// design detail supporting documents — discard a resumable upload (aborts S3 + clears the record)
export const discardResumableSupportingUpload = async (id, taskId) => {
  try {
    return await apiClient.delete(
      `${apiEndpoint}/design/${id}/${API.DESIGN_DETAILS.GET_SUPPORTINGDOC}/pending-uploads/${taskId}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDescDevOrder = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DESC_DEV_ORDER}`, { params: payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductIdentifier = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_PRODUCT_IDENTIFIER}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveProductIdentifier = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_PRODUCT_IDENTIFIER}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCMPageImages = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CM_PAGE_IMAGE_DELETE}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCustomModulePages = async (devId, customLibId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_CM_PAGE_LIST}/${customLibId}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProdctCMPage = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_DELETE_CM_PAGE}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateCopiedPageInLibrary = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_CM_COPY_PAGE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get all CM Dependent List
export const getProductCustomModuleDepednent = async (devId, customLibId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_DEPENDENT_CONTROL_LIST}/${customLibId}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getContentPageData = async (devId, customLibId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_CM_CONTENT_PAGE}/${customLibId}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUpdatedCustomModuleByPages = async (objParam) => {
  try {
    return await apiClient.get(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.REFRESH_CUSTOM_MODULE_PAGES}/${objParam.devOrderId}/${objParam.customModuleLibId}/${objParam.pageId}`,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkDamExist = async (devId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHECK_PRODUCT_DAM_EXIST}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteProductAllDam = async (devId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.DELETE_ALL_PRODUCT_DAM}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductname = async (devId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_PRODUCT_NAME}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDppModule = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_DPP_MODULE_LIST}/${payload.devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportTestingUsageDetails = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.DOWNLOAD_TESTING_USAGE}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const exportProductTestingUsageDetails = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.PRODUCT_DOWNLOAD_TESTING_USAGE}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const setCounterValueNumber = async (brandId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_ALL_COUNTS}?brandId=${brandId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkBomExitInProduct = async (devId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHECK_PRODUCT_BOM_EXIST}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProductAllBom = async (devId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.DELETE_ALL_PRODUCT_BOM}/${devId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomDetailsBasedOnId = async (devId, bomId, bomTypeId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_BOM_DETAILS_ID}/${devId}/${bomTypeId}/${bomId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const saveSampleAnnoationsSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_ANNOTATION_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSupplierAnnoationsSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SUPPLIER_ANNOTATION_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSupplierImageSetSequence = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SUPPLIER_IMAGE_SETS_SEQUENCE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSampleComment = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SAMPLES.DELETE_COMMENT}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getSuggestionDevOrderId = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.SUPPLIER_SUGGESTION_ID}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const changeFactory = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CHANGE_FACTORY}`, { params: { ...params } });
  } catch (error) {
    console.error('API changeFactory error:', error);
    throw error;
  }
};

export const replaceDesignImage = async (devOrderId, designId, imageId, formData) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_SET_DESIGN_DETAIL}/${devOrderId}${API.DESIGN_DETAILS.REPLACE_IMAGE}/${designId}/${imageId}/replace-image`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductDependentData = async (devId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}/${devId}${API.DEVELOPMENT_ORDER.PRODUCT_DEPENDENT_DATA}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDevOrdersByIds = (ids) => apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.ADD_DEV_ORDER}`, { params: { ids: ids.join(',') } });
export const bulkCreateDevOrders = (payload) => apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDER.BULK_CREATE_DEV_ORDER}`, payload);
